import { useRedux } from '../modularRedux';
import reducers from './reducers';

export const storeKey = 'user';

export interface UserState {
  phoneNumber: string | null;
  tempPhoneNumber: string | null;
  emailCorrection: string | null;
  deviceToken: string | null;
  preregisteredUser: string | null; // is this an object?
  initialLoadAmount: number | null; // number?
  role: string | null;
  urlRole: string | null;
  dob: string | null;
  registeredUser: any | null; // is this an object?
  pendingVerification: boolean | null;
  bankName: string | null;
  isParentInvitedByChild: boolean;
  isChildInvitedByParent: boolean;
  currentPlan: string | null; // enum of plans
  walletId: string | null; // is this a number?
  firstName: string;
  partner: string;
  ipAddress: string;
  promotionId: string;
  promoCode: string | null;
  placeholderToken: string | null;
  emailVerificationStatus: string; // enum here?
  needsAccessRequest: boolean;
  shouldGetPricingPlanAfterComplete: boolean;
  creditWaitlistEnabledForFlow: boolean;
  phoneNumberProvided: boolean;
  urlEmail: string;
  registeredUserPhone: string | null;
  nextRegStep: string | null;
  skippedVerification: boolean;
  funding: unknown | null;
  fundingAccounts: Array<unknown> | null;
  preRegPlanSelection: string | null;
  inAppPreReg: boolean;
  failureReason: string | null;
  advocateIsTeen: string | null;
  userIsTeen: boolean; // user is of age 13+
  referralRewardValue: string | null;
  hasExceededMaxVerificationAttempts: boolean;
}

export const initialState: UserState = {
  phoneNumber: null,
  tempPhoneNumber: null,
  emailCorrection: null,
  deviceToken: null,
  preregisteredUser: null,
  initialLoadAmount: null,
  role: null,
  urlRole: null,
  dob: null,
  registeredUser: null,
  pendingVerification: null,
  bankName: null,
  isParentInvitedByChild: false,
  isChildInvitedByParent: false,
  currentPlan: null,
  walletId: null,
  firstName: '',
  partner: '',
  ipAddress: '',
  promotionId: '',
  promoCode: null,
  placeholderToken: null,
  emailVerificationStatus: 'unverified',
  needsAccessRequest: false,
  shouldGetPricingPlanAfterComplete: false,
  creditWaitlistEnabledForFlow: false,
  phoneNumberProvided: true,
  urlEmail: '',
  registeredUserPhone: null,
  nextRegStep: null,
  skippedVerification: false,
  funding: null,
  fundingAccounts: null,
  preRegPlanSelection: null,
  inAppPreReg: false,
  failureReason: null,
  advocateIsTeen: null,
  userIsTeen: false,
  referralRewardValue: null,
  hasExceededMaxVerificationAttempts: false
};

export const [useUser, useUserDispatchers, userActions] = useRedux(
  storeKey,
  reducers,
  initialState
);
